import { PublicClient, erc721Abi, getContract } from 'viem'

import { EvmAddress } from '~/utils/address'

export const getReadErc721Contract = ({
  address,
  publicClient,
}: {
  address: EvmAddress.Type
  publicClient: PublicClient
}) => {
  return getContract({
    address,
    abi: erc721Abi,
    client: publicClient,
  })
}
